module.exports = __webpack_public_path__ + "static/media/Goal-Header-Mobile.064a4405.mp4";